<script>
import ArrowIcon from '@/assets/images/icons/slider-arrow.svg?inline'

export default {
  name: 'NewsCarousel',
  components: {
    ArrowIcon
  },
  data: () => ({
    slider: 0,
    slides: [
      {
        title: 'В России нашли способ привлечь туристов в страну 1',
        text: 'Ростуризм выбрал организацию, которая займется созданием «системы визуальной идентификации и руководства по фирменному стилю туристического бренда» России. Об этом свидетельствуют материалы единой информационной системы в сфере госзакупок.'
      },
      {
        title: 'В России нашли способ привлечь туристов в страну 2',
        text: 'Ростуризм выбрал организацию, которая займется созданием «системы визуальной идентификации и руководства по фирменному стилю туристического бренда» России. Об этом свидетельствуют материалы единой информационной системы в сфере госзакупок.'
      },
      {
        title: 'В России нашли способ привлечь туристов в страну 3',
        text: 'Ростуризм выбрал организацию, которая займется созданием «системы визуальной идентификации и руководства по фирменному стилю туристического бренда» России. Об этом свидетельствуют материалы единой информационной системы в сфере госзакупок.'
      },
      {
        title: 'В России нашли способ привлечь туристов в страну 4',
        text: 'Ростуризм выбрал организацию, которая займется созданием «системы визуальной идентификации и руководства по фирменному стилю туристического бренда» России. Об этом свидетельствуют материалы единой информационной системы в сфере госзакупок.'
      },
      {
        title: 'В России нашли способ привлечь туристов в страну 5',
        text: 'Ростуризм выбрал организацию, которая займется созданием «системы визуальной идентификации и руководства по фирменному стилю туристического бренда» России. Об этом свидетельствуют материалы единой информационной системы в сфере госзакупок.'
      },
      {
        title: 'В России нашли способ привлечь туристов в страну 6',
        text: 'Ростуризм выбрал организацию, которая займется созданием «системы визуальной идентификации и руководства по фирменному стилю туристического бренда» России. Об этом свидетельствуют материалы единой информационной системы в сфере госзакупок.'
      },
    ]
  }),
  methods: {
    slidePrev() {
      this.slider = this.slider === 0
        ? this.slider = this.slides.length - 1
        : this.slider - 1
    },
    slideNext() {
      this.slider = this.slider === this.slides.length - 1
        ? this.slider = 0
        : this.slider + 1
    }
  }
}
</script>
<template>
  <div class="news-carousel app-content">
    <div class="news-carousel__header">
      <h2 class="main-page__title">
        Новости
      </h2>
      <router-link to="/">
        Все новости
      </router-link>
    </div>
    <div class="news-carousel__controls">
      <button
        class="news-carousel__controls-button news-carousel__controls-button--prev"
        @click="slidePrev"
      >
        <arrow-icon
          fill="#ababab"
        />
      </button>
      <button
        class="news-carousel__controls-button"
        @click="slideNext"
      >
        <arrow-icon
          fill="#ababab"
        />
      </button>
    </div>
    <b-carousel-list
      v-model="slider"
      :data="slides"
      :items-to-show="2"
      :arrow="false"
    >
      <template
        slot="item"
        slot-scope="props"
      >
        <div class="news-carousel__card">
          <p class="news-carousel__card-title">
            {{ props.list.title }}
          </p>
          <p class="news-carousel__card-description">
            {{ props.list.text }}
          </p>
          <a href="#">Перейти к новости</a>
        </div>
      </template>
    </b-carousel-list>
  </div>
</template>